import withOrdersRouter from './withOrdersRouter';

export default withOrdersRouter;
